import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './product-cs-offering-comparative-view.component.scss';
var ProductCsOfferingComparativeView = /** @class */ (function (_super) {
    tslib_1.__extends(ProductCsOfferingComparativeView, _super);
    function ProductCsOfferingComparativeView(element) {
        return _super.call(this, element) || this;
    }
    ProductCsOfferingComparativeView.prototype.init = function () {
    };
    ProductCsOfferingComparativeView.prototype.bindEvents = function () {
    };
    return ProductCsOfferingComparativeView;
}(Base));
export { ProductCsOfferingComparativeView };



//////////////////
// WEBPACK FOOTER
// ./components/product-cs-offering-comparative-view/product-cs-offering-comparative-view.component.ts
// module id = 786
// module chunks = 0